import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var revamp = config.revamp;
var links = "links/";
var staticFooterURL = {
    exchangeHoldiday: config.jmw + revamp + config.jmw_content + links + "exchangeHolidays",
    circularUpdate: config.jmw + revamp + config.jmw_content + links + "circularUpdates",
    feedbackUrl: config.jmw + config.reportBase + "util-platform/feedback",
    faqitems: config.jmw + config.jmw_market_env + config.jmw_market + "faq/faqtablist",
    locateUsUrl: config.jmw + config.jmw_market_env + config.jmw_market + "locateUs",
};
export default staticFooterURL;
